import moment from 'moment'

function dataExport(state={
  range: [moment().startOf('year'), moment()],
  // isPremium: false,
  "additional_recipients": [],
  "file_type": "csv",
  "purpose": null,
  "income_source": null,
  "entity": null,
  "send_to_accountant": false,
  "isFetchingInitialPoll": true,
  type: null
}, action) {
  switch (action.type) {
    case 'GET_DATA_EXPORTS_SUCCESS':
      return {
        ...state,
        isFetchingInitialPoll: false
      }
    // case 'USER_SUCCESS':
    //   return {
    //     ...state,
    //     isPremium: !!action.user.subscription,
    //   }
    // case "TOGGLE_PREMIUM":
    //   return {
    //     ...state,
    //     isPremium: !state.isPremium
    //   }

    default:
      return state
  }
}

export default dataExport



// WEBPACK FOOTER //
// ./src/account/data-export/reducer.js